import { render } from "./Ecard.vue?vue&type=template&id=5275b3f4"
import script from "./Ecard.vue?vue&type=script&lang=js"
export * from "./Ecard.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__